/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SegmentsGetSegmentAudioQueryResponse, SegmentsGetSegmentAudioPathParams, SegmentsGetSegmentAudio400, SegmentsGetSegmentAudio401, SegmentsGetSegmentAudio403, SegmentsGetSegmentAudio404 } from "../models/SegmentsGetSegmentAudio";

export function getSegmentsGetSegmentAudioUrl(station: SegmentsGetSegmentAudioPathParams["station"], segment: SegmentsGetSegmentAudioPathParams["segment"]) {
  const res = { method: 'GET', url: `/segments/v1/stations/${station}/segments/${segment}/audio` as const }
  return res
}

/**
 * @summary Get segment audio
 * {@link /segments/v1/stations/:station/segments/:segment/audio}
 */
export async function segmentsGetSegmentAudio(station: SegmentsGetSegmentAudioPathParams["station"], segment: SegmentsGetSegmentAudioPathParams["segment"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SegmentsGetSegmentAudioQueryResponse, ResponseErrorConfig<SegmentsGetSegmentAudio400 | SegmentsGetSegmentAudio401 | SegmentsGetSegmentAudio403 | SegmentsGetSegmentAudio404>, unknown>({ method : "GET", url : getSegmentsGetSegmentAudioUrl(station, segment).url.toString(), ... requestConfig })
  return res.data
}